namespace GeniuzPOS.Lookups {
    export interface LookupBgColorForm {
        BgColor: Serenity.StringEditor;
        BgColorName: Serenity.StringEditor;
    }

    export class LookupBgColorForm extends Serenity.PrefixedContext {
        static formKey = 'Lookups.LookupBgColor';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LookupBgColorForm.init)  {
                LookupBgColorForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(LookupBgColorForm, [
                    'BgColor', w0,
                    'BgColorName', w0
                ]);
            }
        }
    }
}
